import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
  ],
});

export const styles = StyleSheet.create({
  page: {
    backgroundColor: '#F5F5F5',
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '100%',
  },
  pageWrapper: {
    position: 'relative',
    width: '70%',
    height: '100%',
    color: '#27343d',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: 53,
    paddingTop: 40,
  },

  title: {
    color: 'black',
    fontFamily: 'Lato',
    fontSize: 40,
    fontWeight: 900,
    textTransform: 'uppercase',
  },
  highlightedTitle: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 24,
    fontWeight: 700,
    textTransform: 'uppercase',
    marginBottom: 10,
  },

  galleryContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    width: 1340,
    columnGap: 40,
    rowGap: 25,
    marginTop: 30,
  },
  logoWrapper: {
    backgroundColor: '#ffffff',
    borderRadius: 10,
    padding: 5,
    width: '22.5%',
    height: 155,
  },
  logoImage: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    borderRadius: 10,
  },
});
